import { Directive, ElementRef } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appNoWhiteSpace]',
  host: { '(blur)': 'trimText($trimText)' }
})

export class NoWhiteSpaceDirective {
  constructor(private elementRef: ElementRef, private ngControl: NgControl) { }

  trimText() {
    this.elementRef.nativeElement.value = (this.elementRef.nativeElement.value || '').trim();
    this.ngControl.control.setValue(this.elementRef.nativeElement.value);
  }
}
